<template>
  <div :style="`min-height:${contentHeight}px`" class="position-relative">
    <div :style="`min-height:${contentHeight / 2}px`">
      <div>
        <div class="d-flex align-items-center">
          <h6 class="mb-0">
            {{ $l('form_header_fabricSeriesImage') || '面料系列图片' }}
          </h6>
          <el-divider direction="vertical" v-if="!disabled" />
          <el-button
            v-if="!disabled"
            style="font-size: 14px;"
            type="text"
            @click="uploadImage"
          >
            {{ $l('btn_uploadFabricImage') || '上传图片' }}
          </el-button>
        </div>

        <div
          class="d-flex flex-wrap block"
          v-if="listImageView && listImageView.length"
        >
          <vuedraggable
            @end="draggableEnd"
            :list.sync="listImage"
            :disabled="disabled"
            tag="div"
            draggable=".draggable-item"
            class="d-flex flex-wrap"
          >
            <div
              v-for="(item, index) in listImageView"
              :key="index"
              class="draggable-item"
            >
              <el-tooltip
                placement="top"
                :content="$l('INDEX.tooltip_mouse_click_drag') || '鼠标点击拖动'"
                :disabled="disabled"
              >
                <div class="image-box">
                  <span
                    v-if="'Y' === listImage[index].isDefault"
                    class="default-icon"
                  >
                    <i class="el-icon-success" />
                  </span>
                  <el-image
                    style="width: 100%; height: 100%"
                    fit="cover"
                    :src="item"
                  />
                  <div
                    class="shadow d-flex align-items-center justify-content-center"
                  >
                    <div>
                      <span @click="previewImage(index)">
                        <i class="el-icon-zoom-in"></i
                      ></span>
                      <span
                        v-if="!disabled"
                        @click="setDefaultImage(index)"
                        class="ml-2"
                      >
                        <i class="el-icon-check"></i
                      ></span>
                      <span
                        v-if="!disabled"
                        @click="delImage(index)"
                        class="ml-2"
                      >
                        <i class="el-icon-delete-solid"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </el-tooltip>
            </div>
          </vuedraggable>
        </div>
        <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
          <img
            v-for="(item, index) in listImage"
            :src="item.displayImageUrl || '/image/static/img/nopic.jpg'"
            :key="index"
          />
        </div>
      </div>
    </div>
    <div
      style="text-align: center;top: 40%;left: 40%;"
      v-if="!listImageView || !listImageView.length"
    >
      <img src="/image/static/img/nodata.png" />
      <p class="no-data mt-2">
        {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
      </p>
    </div>
  </div>
</template>
<script>
import vuedraggable from 'vuedraggable'
import { VXETable } from 'vxe-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { vuedraggable },
  props: {
    fabricSeriesCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { listImage: [] }
  },
  computed: {
    listImageView() {
      return this.listImage.map((image) => image.displayImageUrl)
    },
    contentHeight() {
      return window.innerHeight - 340
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.fabricSeriesCode) return
      const res = await this.$api
        .masterFabricSeriesImageListApi({ fabricSeriesCode: this.fabricSeriesCode })
        .catch(() => null)
      this.listImage = [...(res?.body?.data || [])]
    },
    async uploadImage() {
      const { files } = await VXETable.readFile({
        types: ['jpeg', 'JPEG', 'jpg', 'JPG', 'png', 'PNG', 'gif', 'GIF'],
        multiple: true,
      }).catch(() => ({}))
      if (!files?.length) return

      if (files.length > 10) {
        const msg = `${this.$l('INDEX.tips_warning_uploadLimit_1') ||
          '当前限制一次选择10张图片，本次选择了'} ${files.length} ${this.$l(
          'tips_warning_uploadLimit_2'
        ) || '张图片'}`
        this.$message.warning(msg)
        return
      }

      const uploadTask = Array.from(files).map((item) =>
        this.$api
          .SYS_UPLOAD(item)
          .then((res) => ({
            originImageCode: res.body.fileId,
            originImageUrl: res.body.url,
            originImageSpec: item.type,
          }))
          .catch(() => null)
      )

      if (this.loadingOpen()) return
      const listImage = await Promise.all(uploadTask)
      if (listImage.includes(null)) {
        this.$message.warning(
          this.$l('INDEX.tips_warning_upload') || '面料图片上传失败，请联系管理员'
        )
        this.loadingClose()
        return
      }

      const params = { fabricSeriesCode: this.fabricSeriesCode, listImage }
      const res = await this.$api
        .masterFabricSeriesImageUploadApi(params)
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success'),
        type: 'success',
      })
      this.getData()
      this.$emit('reload')
    },
    previewImage(index) {
      if (!this.listImage?.length) return
      this.viewer = this.$el.querySelector('.imagesViewer').$viewer
      this.viewer.view(index)
      this.viewer.show()
    },
    async setDefaultImage(index) {
      const { masterFabricSeriesImgCode } = this.listImage[index]
      if (!masterFabricSeriesImgCode) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterFabricSeriesImageSetDefaultApi({ masterFabricSeriesImgCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_set_no') || '设置失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_set_ok') || '设置成功！',
        type: 'success',
      })
      this.getData()
      this.$emit('reload')
    },
    async delImage(index) {
      const { masterFabricSeriesImgCode } = this.listImage[index]
      if (!masterFabricSeriesImgCode) return

      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .masterFabricSeriesImageDelApi({ masterFabricSeriesImgCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.getData()
      this.$emit('reload')
    },
    async draggableEnd() {
      const listMasterFabricSeriesImgCode = this.listImage.map(
        (item) => item.masterFabricSeriesImgCode,
      )
      if (!listMasterFabricSeriesImgCode?.length) return
      if (this.loadingOpen()) return

      const params = { listMasterFabricSeriesImgCode, fabricSeriesCode: this.fabricSeriesCode }
      const res = await this.$api
        .masterFabricSeriesImageUpdateSortOrderApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_operate_no') || '操作失败！')
        return
      }
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.image-box {
  width: 140px;
  height: 140px;
  line-height: 140px;
  position: relative;
  background-color: #fbfdff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  margin: 8px;
  position: relative;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}
.el-upload-list__item.is-ready {
  display: none;
}

.shadow {
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
}

.no-data {
  color: #606266;
  font-size: 13px;
}
</style>
